<style lang="scss">
.deleted-row td {
  opacity: 0.5;
}
</style>

<!-- eslint-disable -->
<template>
  <div class="theme-color-wrapper p-2">
    <div class="row">
      <div class="col-12">
        <section class="d-flex align-items-center sm-row-drop mb-sm-2">
          <h2 class="font-weight-bolder mb-sm-0 mb-2">Manage Users</h2>
          <div class="ui-spacer"></div>
          <b-btn @click="showModal('modal-create-user')" variant="success" class="sm-full-width mb-sm-0 mb-2">
            Create User
          </b-btn>
        </section>

        <section v-if="!loading">
          <b-table
            class="data-table mx-0 px-0"
            hover
            :items="users"
            :fields="columns"
            :current-page="currentPage"
            :per-page="perPage"
            :responsive="true"
            :tbody-tr-class="row => row.deleted_at ? 'deleted-row' : ''"
          >
            <template #cell(username)="data">
              {{ data.item.username }}
              <b-badge v-if="data.item.deleted_at" variant="danger" class="ml-1">Deleted</b-badge>
            </template>
            <template #cell(actions)="data">
              <b-dropdown v-if="!data.item.deleted_at" variant="link" right toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item-button class="full-nested-btn" @click="deleteUser(data.item)">
                  Delete User
                </b-dropdown-item-button>
              </b-dropdown>
            </template>
          </b-table>
          <b-row>
            <b-col md="6" class="my-1" v-if="users.length > 0">
              <b-pagination :total-rows="users.length" :per-page="perPage" v-model="currentPage" class="my-0"/>
            </b-col>
            <p v-else class="ml-1">No users found.</p>
          </b-row>
        </section>

        <b-spinner class="d-block" v-else variant="primary"></b-spinner>
      </div>
    </div>

    <b-modal id="modal-create-user" title="Create User" hide-footer>
      <b-form @submit.prevent="createUser">
        <b-form-group label="Username" label-for="new-username">
          <b-form-input id="new-username" v-model="newUser.username" required></b-form-input>
        </b-form-group>
        <b-form-group label="Password" label-for="new-password">
          <b-form-input id="new-password" v-model="newUser.password" type="password" required></b-form-input>
        </b-form-group>
        <b-form-group label="Name" label-for="new-name">
          <b-form-input id="new-name" v-model="newUser.name"></b-form-input>
        </b-form-group>
        <b-form-group label="Email" label-for="new-email">
          <b-form-input id="new-email" v-model="newUser.email" type="email"></b-form-input>
        </b-form-group>
        <div class="d-flex justify-content-end">
          <b-btn variant="secondary" class="mr-2" @click="hideModal('modal-create-user')">Cancel</b-btn>
          <b-btn variant="success" type="submit" :disabled="submitting">Create</b-btn>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>
<!-- eslint-enable -->

<script>
import UserManagerService from '@/services/UserManagerService';

export default {
  name: 'ManageUsers',
  data() {
    return {
      loading: true,
      submitting: false,
      users: [],
      columns: [
        { key: 'username', label: 'Username' },
        { key: 'name', label: 'Name' },
        { key: 'email', label: 'Email' },
        { key: 'actions', label: 'Actions' },
      ],
      currentPage: 1,
      perPage: 10,
      newUser: {
        username: '',
        password: '',
        name: '',
        email: '',
      },
    };
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    getUsers() {
      this.loading = true;
      UserManagerService.getUsers().then(res => {
        this.users = res.data;
      }).catch(() => {
        this.$toast.error('Error loading users, please refresh and try again.', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    createUser() {
      this.submitting = true;
      UserManagerService.createUser(this.newUser).then(() => {
        this.$toast.success('User created successfully.');
        this.hideModal('modal-create-user');
        this.resetNewUser();
        this.getUsers();
      }).catch(() => {
        this.$toast.error('Error creating user. The username may already exist.', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.submitting = false;
      });
    },
    deleteUser(user) {
      this.$bvModal.msgBoxConfirm(`Are you sure you want to delete ${user.username}? They will no longer be able to log in.`, {
        title: 'Delete User',
        okTitle: 'Delete',
        okVariant: 'danger',
        cancelTitle: 'Cancel',
      }).then(confirmed => {
        if (!confirmed) return;
        UserManagerService.deleteUser(user.user_id).then(() => {
          this.$toast.success(`${user.username} has been deleted.`);
          this.getUsers();
        }).catch(() => {
          this.$toast.error('Error deleting user. Please try again.', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      });
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    resetNewUser() {
      this.newUser = { username: '', password: '', name: '', email: '' };
    },
  },
};
</script>
